import React from "react";
import {Box, List, ListItem, ListItemButton, ListItemText, Paper, Stack, Typography,} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicListDisabled = () => {
    return (
        <Stack spacing={2} p={3}>
            <Box>
                <Typography variant={"h6"} color={"text.primary"}>
                    Disabled List Item
                </Typography>
            </Box>
            <Box sx={{ width: "80%", alignSelf: "center" }}>
                <PreviewAndEditor
                    language="js"
                    background
                    value={"            <List disablePadding >\n" +
                        "                        <ListItem disablePadding>\n" +
                        "                            <ListItemButton disabled>\n" +
                        "                                <ListItemText primary=\"Inbox\" />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                        <ListItem disablePadding >\n" +
                        "                            <ListItemButton disabled>\n" +
                        "                                <ListItemText primary=\"Drafts\" />\n" +
                        "                            </ListItemButton>\n" +
                        "                        </ListItem>\n" +
                        "                    </List>"}
                >
                    <Paper p={3} elevation={0} sx={{width: 250}}>
                    <List disablePadding >
                        <ListItem disablePadding>
                            <ListItemButton disabled>
                                <ListItemText primary="Inbox" />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding >
                            <ListItemButton disabled>
                                <ListItemText primary="Drafts" />
                            </ListItemButton>
                        </ListItem>
                    </List>
                    </Paper>
                </PreviewAndEditor>
            </Box>
        </Stack>
    );
};

export default BasicListDisabled;
